import React from "react";

import {
  CANINE_LEFT_SHAPES,
  CANINE_RIGHT_SHAPES,
  renderShape,
} from "./utils";

const CanineDentalChart = ({ toothConditions }) => {
  return (
    <svg
      viewBox="-14 0 200 405"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="-4"
        y="202.5"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#64748b"
        fontSize="14"
        fontFamily="sans-serif"
        fontWeight="bold"
      >
        R
      </text>
      <text
        x="176"
        y="202.5"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#64748b"
        fontSize="14"
        fontFamily="sans-serif"
        fontWeight="bold"
      >
        L
      </text>
      <g id="Canine">
        <g id="Canine-Right">
          {CANINE_RIGHT_SHAPES.map(({ type, id, ...props }) =>
            renderShape(type, id, props, toothConditions),
          )}
        </g>
        <g id="Canine-Left">
          {CANINE_LEFT_SHAPES.map(({ type, id, ...props }) =>
            renderShape(type, id, props, toothConditions),
          )}
        </g>
      </g>
    </svg>
  );
};

export default CanineDentalChart;
